module.exports = __webpack_public_path__ + "static/media/scratch_view.34222959.png";